/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ErrorMessage } from '@hookform/error-message';
import { site } from '@panel/commons/helpers';
import { FieldError, FieldRow } from '../../../styles';
import { InputField, SelectField } from '../fields';
import { getLocationLevel, setSelectedLocation, selectAvailableLocations } from '../../../../../../ducks/step4Module2';

function BillingLocation({ updateTaxes }) {
  const { getValues, setValue } = useFormContext();
  const { states, cities, zones, subZones } = useSelector(selectAvailableLocations);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const formatPostalCode = e => {
    if (site.isBrasil) {
      e.target.maxLength = '9';
      const formattedValue = getValues('postalCode')
        .replace(/\s/g, '')
        .match(/\d{1,5}/g)
        ?.join('-');
      setValue('postalCode', formattedValue);
    }
  };

  useEffect(() => {
    dispatch(getLocationLevel());
  }, [dispatch]);

  const handleSelectLocation = e => {
    dispatch(setSelectedLocation(e.target.value));
    dispatch(getLocationLevel(e.target.value));
  };

  return (
    <>
      <FieldRow>
        <InputField
          name='address'
          section='billing'
          onBlur={updateTaxes}
          renderError={errorProps => (
            <ErrorMessage {...errorProps} render={({ message }) => <FieldError>{t(message)}</FieldError>} />
          )}
        />
        {!site.isPeru && (
          <InputField
            name='postalCode'
            onBlur={updateTaxes}
            onChange={formatPostalCode}
            renderError={errorProps => (
              <ErrorMessage {...errorProps} render={({ message }) => <FieldError>{t(message)}</FieldError>} />
            )}
          />
        )}
      </FieldRow>
      <FieldRow>
        <SelectField
          name='locationState'
          options={states}
          onChange={handleSelectLocation}
          renderError={errorProps => (
            <ErrorMessage {...errorProps} render={({ message }) => <FieldError>{t(message)}</FieldError>} />
          )}
        />
        <SelectField
          name='locationCity'
          options={cities}
          disabled={!cities}
          onChange={handleSelectLocation}
          renderError={errorProps => (
            <ErrorMessage {...errorProps} render={({ message }) => <FieldError>{t(message)}</FieldError>} />
          )}
        />
      </FieldRow>
      <FieldRow>
        {zones && (
          <SelectField
            name='locationZone'
            options={zones}
            disabled={!zones}
            onChange={handleSelectLocation}
            renderError={errorProps => (
              <ErrorMessage {...errorProps} render={({ message }) => <FieldError>{t(message)}</FieldError>} />
            )}
          />
        )}
        {subZones && (
          <SelectField
            name='locationSubZone'
            options={subZones}
            disabled={!subZones}
            onChange={handleSelectLocation}
            renderError={errorProps => (
              <ErrorMessage {...errorProps} render={({ message }) => <FieldError>{t(message)}</FieldError>} />
            )}
          />
        )}
      </FieldRow>
    </>
  );
}

export default BillingLocation;
